import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { EscrowContractAddress } from "../Services/EscrowContractAddress";
import EscrowContractAbi from "../Services/EscrowContractAbi.json";
import BEPContractAbi from "../Services/BEPContractAbi.json";
import { BEPContractAddress } from "../Services/BEPContractAddress";
import { EthContracatAddress } from "../Services/EthContractAddress";
import EthContractAbi from "../Services/EthContracatAbi.json";
import ETContractAbi from "../Services/ETContractAbi.json";
import { Spinner } from "flowbite-react";
import { useSigner, useNetwork } from "wagmi";
import React from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
const { BigNumber } = require("ethers");

const AccountsForm = () => {
  const { chain } = useNetwork();
  //-------------------------------TOKEN CONTRACT ADDRESS----------------------------------//
  useEffect(() => {
    // console.log("useEffect", chain.id);
  }, [chain]);

  //---------------------------Use-States---------------------------------//
  const { data: signer } = useSigner();

  let [isOpen, setIsOpen] = useState(false);
  let [waiting, setWaiting] = useState(true);
  const [reciveraddress, setReciverAddress] = useState();
  const [amount, setAmount] = useState();

  const [dateTime, setDateTime] = useState();

  const [futureDate, setFutureDate] = useState(); //

  const navigate = useNavigate();
  //const history = useHistory();

  //-------------------------useEffect----------------------------------//

  //--------toogle DATE TIME MODAL---------------------//
  const DateModal = () => {
    setIsOpen(!isOpen);
  };
  let unixTimestamp;
  let timeMfive;

  //------------------HANDLE DATE AND TIME CHANGE USING MOMENTUM------------------------//
  function handleDateTimeChange(event) {
    setDateTime(event.target.value);
    //console.log("in milli seconds", dateTime);
    const bb = new Date(dateTime).getTime();
    // console.log("Time in seconds i hguess",bb)
    unixTimestamp = Math.floor(new Date(dateTime).getTime() / 1000);
    // console.log("Unix Time Stamp", unixTimestamp);

    timeMfive = unixTimestamp - 18000;
    setFutureDate(timeMfive);
    // console.log("future timestamp" + timeMfive);
  }

  //---------------------------nf-----------------------------------------------//
  const feeinPerc = (num, weii) => {
    const fee = num / 10;

    const All = (fee * weii) / 100;

    return All;
  };

  //--------------------------CREATING ESCROW CONTRACT ADDRESS---------------------//
  const createEscrowContract = async () => {
    // console.log("account form chain id ", chain.id);

    if (chain.id === 11155111) {
      if (reciveraddress && amount && dateTime && signer) {
        setWaiting(false);

        const Contract = new ethers.Contract(
          EthContracatAddress,
          EthContractAbi,
          signer
        );
        console.log("Contract Eth", Contract);
        const BEPContract = new ethers.Contract(
          "0x776820f1a6adbED4B790EA58a01Af2d5F7E02967",
          ETContractAbi,
          signer
        );

        localStorage.setItem("receiverAddress", reciveraddress);
        localStorage.setItem("BTCamount", amount);

        const wei = ethers.utils.parseEther(amount.toString());

        const weii = parseInt(wei.toString());

        const fee = await Contract.dioFee();
        const bigNumber = BigNumber.from(fee._hex);
        const diofee = bigNumber.toString();
        const signerAddress = await axios
          .get(`${process.env.React_App_baseUrl}current-address`)
          .then(async (_res) => {
            return _res.data.address;
          })
          
        console.log("Signer Addres", signerAddress);

        const Allowance = await feeinPerc(diofee, weii);
        const tokenapprove = await Contract.getPriceOfTokens(
          Allowance.toString()
        );
        const bigtoken = BigNumber.from(tokenapprove._hex);
        const token = bigtoken.toString();

        const tokeninEther = ethers.utils.formatEther(token.toString());

        const gasfee = await Contract.gasFee(); // contract gas fee
        const gf = parseInt(gasfee);
        const executionFee = await Contract.executionFee(); // custom Signer Execution Fee

        const eF = parseInt(executionFee);

        const gasFee = weii + gf + eF;
        console.log("INITIAL AMOUNT", weii);
        console.log("GAS FEE", gf);
        console.log("Execution Fee", eF);
        console.log("Total Amount need to be send", gasFee);

        const executionTime = Math.floor(new Date(dateTime).getTime() / 1000);

        try {
          const address = await signer.getAddress();

          await BEPContract?.balanceOf(address).then(async (_blnce) => {
            const bigNumber = BigNumber.from(_blnce._hex);
            const DioBalance = bigNumber.toString(); // time in seconds from the contract
            const dioInEth = ethers.utils.formatEther(DioBalance);
            const dioFloat = parseFloat(dioInEth);
            const tokenFloat = parseFloat(tokeninEther);

            if (tokenFloat > dioFloat) {
              console.log("DioBalance", DioBalance);
              toast.error("Insufficeint Dio");
              setWaiting(true);
            } else {
              await BEPContract?.approve(EthContracatAddress, token.toString())
                .then((allowanceA_Response) => {
                  toast("Allowance is being approved please wait");
                  allowanceA_Response.wait().then(async () => {
                    await Contract?.createEscrowContract(
                      reciveraddress,
                      wei,
                      executionTime, 
                      signerAddress,
                      {
                        value: gasFee,
                      },
                     
                    )
                      .then((response) => {
                        toast("Transaction is being confirmed please wait");

                        response.wait().then(async () => {
                          const hash = response.hash;

                          localStorage.setItem("EthHash", hash);
                          await setWaiting(true);
                          navigate("/completed");
                        });
                      })
                      .catch((error) => {
                        toast.error("Some thing went wrong try again");
                        setWaiting(true);
                      });
                  });
                })
                .catch((error) => {
                  toast.error("Some thing went wrong try again");
                  setWaiting(true);
                });
            }
          });
        } catch (error) {
          console.log("errrrrrrr", error);
          setWaiting(true);
        }
      } else {
        console.log("Please fill all data");
      }
    } else {
      if (reciveraddress && amount && dateTime && signer) {
        setWaiting(false);

         console.log("Createing EscrowContract");
        const Contract = new ethers.Contract(
          EscrowContractAddress,
          EscrowContractAbi,
          signer
        );
        const BEPContract = new ethers.Contract(
          BEPContractAddress,
          BEPContractAbi,
          signer
        );
console.log("CONTRACTTT",Contract)
        localStorage.setItem("receiverAddress", reciveraddress);
        localStorage.setItem("BTCamount", amount);
        const signerAddress = await axios
          .get(`${process.env.React_App_baseUrl}current-address`)
          .then(async (_res) => {
            return _res.data.address;
          })
          
        console.log("Signer Addres", signerAddress);

        const wei = ethers.utils.parseEther(amount.toString());

        const weii = parseInt(wei.toString());

        const fee = await Contract.dioFee()
        const bigNumber = BigNumber.from(fee._hex);
        const diofee = bigNumber.toString();

        const Allowance = await feeinPerc(diofee, weii);
        const tokenapprove = await Contract.getPriceOfTokens(
          Allowance.toString()
        );
        const bigtoken = BigNumber.from(tokenapprove._hex);
        const token = bigtoken.toString();

        const tokenInEther = ethers.utils.formatEther(token.toString());

        const gasfee = await Contract.gasFee(); // Contract gas fee

        const gf = parseInt(gasfee);
        const executionFee = await Contract.executionFee(); // Custom Signer Execution Fee
        const eF = parseInt(executionFee);
        console.log("INITIAL AMOUNT", weii);
        console.log("GAS FEE", gf);
        console.log("Execution Fee", eF);

        const gasFee = weii + gf + eF;
        console.log("Total Amount need to be send", gasFee);

        const executionTime = Math.floor(new Date(dateTime).getTime() / 1000);

        try {
          const address = await signer.getAddress();
          await BEPContract?.balanceOf(address).then(async (_blnce) => {
            const bigNumber = BigNumber.from(_blnce._hex);
            const DioBalance = bigNumber.toString(); // time in seconds from the contract
            const dioInEth = ethers.utils.formatEther(DioBalance);
            const dioFloat = parseFloat(dioInEth);
            const tokenFloat = parseFloat(tokenInEther);

            if (tokenFloat > dioFloat) {
              toast.error("Insufficeint Dio");
              setWaiting(true);
            } else {
              await BEPContract?.approve(
                EscrowContractAddress,
                token.toString()
              )
                .then((allowanceA_Response) => {
                  toast("Allowance is being approved please wait");
                  allowanceA_Response.wait().then(async () => {
                    await Contract?.createEscrowContract(
                      reciveraddress,
                      wei,
                      executionTime,
                      signerAddress,
                      {
                        value: gasFee,
                      }
                    )
                      .then((response) => {
                        toast("Transaction is being confirmed please wait");
                        response.wait().then(async () => {
                          // console.log(response);
                          localStorage.setItem("BEPhash", response.hash);
                          await setWaiting(true);
                          navigate("/completed");
                        });
                      })
                      .catch((error) => {
                        console.log("error",error)
                        toast.error("Some thing  went wrong please try again");
                        setWaiting(true);
                      });
                  });
                })
                .catch((error) => {
                  console.log("error",error)
                  toast.error("Some thing  went wrong please try again");
                  setWaiting(true);
                });
            }
          })
        } catch (error) {
          console.log(error);
          setWaiting(true);
        }
      } else {
        
        toast.error("Please fill all data");
      }
    }
  };

  //---------------testing---------------//
  const test = () => {
    setWaiting(false);
  };

  return (
    <div className="h-screen flex items-center justify-center ">
      {waiting ? (
        <div className="bg-slate-100  p-20 h-fit shadow-md  ">
          <h1
            className="text-center text-3xl text-slate-600 font-semibold"
            onClick={test}
          >
            Send
          </h1>
          <h1 className="mt-4 text-slate-600">Recipient</h1>
          <div class=" py-2 md:py-0">
            <label for="UserEmail" class="sr-only"></label>

            <input
              type="email"
              id="Recipient"
              placeholder=" Enter receiver address"
              class="w-full rounded-lg border border-gray-600 pr-10 shadow-sm sm:text-sm py-2 px-2 "
              onChange={(e) => setReciverAddress(e.target.value)}
            />

            <span class="pointer-events-none absolute inset-y-0 right-0 grid w-10 place-content-center text-gray-500"></span>
          </div>

          <div className="flex items-center ">
            <div className=" text-green-600 tracking-wider font-semibold text-xl ">
              <p></p>

              {/* DATE AND TIME */}
              <h1 className="py-4" onClick={DateModal}>
                {" "}
                Select Execution Time
              </h1>

              <input
                type="datetime-local"
                value={dateTime}
                onChange={handleDateTimeChange}
                min={new Date().toISOString().slice(0, -8)}
              />
            </div>
          </div>
          <h1 className=" text-slate-600">Amount</h1>
          <div className=" items-center gap-4">
            <div class=" py-2 md:py-0">
              <label for="UserEmail" class="sr-only"></label>

              <input
                type="email"
                id="Recipient"
                placeholder=" Input Here"
                class="w-full rounded-lg border border-gray-600 pr-10 shadow-sm sm:text-sm py-2 px-2 "
                onChange={(e) => setAmount(e.target.value)}
              />

              <span class="pointer-events-none absolute inset-y-0 right-0 grid w-10 place-content-center text-gray-500"></span>
            </div>
          </div>

          <div className="md:flex flex flex-row items-center gap-4  mt-8">
            <NavLink to={"/"}>
              <button className=" border rounded-full py-2 px-8 mt-2  md:mt-0 bg-slate-200 hover:bg-slate-400 w-fit text-md ">
                {" "}
                Cancel
              </button>
            </NavLink>{" "}
            <button
              className=" border rounded-full py-2 px-8 mt-2   md:mt-0 bg-slate-200 hover:bg-slate-400 w-fit text-md"
              onClick={createEscrowContract}
            >
              {" "}
              Send
            </button>
          </div>
        </div>
      ) : (
        <Spinner />
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};

export default AccountsForm;
